module.exports = __webpack_public_path__ + "2806a486b202251c20091cbd35643d66.jpg";